
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gf7Jt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $3izAL = parcelRequire("3izAL");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");


var $5dDC4 = parcelRequire("5dDC4");

var $4zyjT = parcelRequire("4zyjT");

var $a96iv = parcelRequire("a96iv");

var $hjUDQ = parcelRequire("hjUDQ");

var $cfM7x = parcelRequire("cfM7x");





var $f8dGE = parcelRequire("f8dGE");


var $iwjSV = parcelRequire("iwjSV");


var $hiHdh = parcelRequire("hiHdh");


var $6THkE = parcelRequire("6THkE");


var $8Yw12 = parcelRequire("8Yw12");




const $bcbc0d6f4b7dc8cf$var$bfsTraverse = (items, callback)=>{
    const queue = [
        ...items
    ];
    while(queue.length > 0){
        const currentItem = queue.shift();
        if (callback(currentItem)) break;
        if (currentItem.type === (0, $8Yw12.ITEM).MENU && currentItem.childItems) queue.push(...currentItem.childItems);
    }
    return items;
};
const $bcbc0d6f4b7dc8cf$export$133e0070ec60504c = (items, item, parentId, position)=>{
    const addItemToParentInPlace = (itemsToTraverse, parentId, item, position)=>{
        return $bcbc0d6f4b7dc8cf$var$bfsTraverse(itemsToTraverse, (currentItem)=>{
            if (currentItem.itemId === parentId && currentItem.type === (0, $8Yw12.ITEM).MENU) {
                if (position !== undefined && position >= 0 && position <= currentItem.childItems.length) currentItem.childItems.splice(position, 0, item);
                else currentItem.childItems = [
                    ...currentItem.childItems || [],
                    item
                ];
                return true;
            }
            return false;
        });
    };
    let newItems;
    if (parentId !== undefined) newItems = addItemToParentInPlace(items, parentId, item, position);
    else {
        const itemsLength = items.length;
        const newPosition = position !== undefined && position >= 0 && position <= itemsLength ? position : itemsLength;
        newItems = [
            ...items
        ];
        newItems.splice(newPosition, 0, item);
    }
    return newItems;
};
const $bcbc0d6f4b7dc8cf$export$2d1285fd35af5519 = (items, updatedItem)=>{
    return $bcbc0d6f4b7dc8cf$var$bfsTraverse(items, (currentItem)=>{
        if (currentItem.itemId === updatedItem.itemId) {
            Object.assign(currentItem, updatedItem);
            return true;
        }
        return false;
    });
};
const $bcbc0d6f4b7dc8cf$export$49f42e821420f72e = (items, itemId)=>{
    return items.map((item)=>{
        if (item.type === (0, $8Yw12.ITEM).MENU && item.childItems) item.childItems = $bcbc0d6f4b7dc8cf$export$49f42e821420f72e(item.childItems, itemId);
        return item;
    }).filter((item)=>item.itemId !== itemId);
};


const $5a630f948a937af8$var$MAXIMUM_ITEM_LIMIT = 50;
const $5a630f948a937af8$var$MAXIMUM_NESTING_LEVELS = 5;
const $5a630f948a937af8$export$8555315c03db9dc2 = ()=>$5a630f948a937af8$var$MAXIMUM_ITEM_LIMIT;
const $5a630f948a937af8$export$3fcb5b76d26bf473 = ()=>$5a630f948a937af8$var$MAXIMUM_NESTING_LEVELS;
const $5a630f948a937af8$export$b503abd6de82eca1 = (items)=>{
    return items?.reduce((acc, item)=>{
        return acc + 1 + $5a630f948a937af8$export$b503abd6de82eca1(item?.childItems);
    }, 0) || 0;
};
const $5a630f948a937af8$var$fetchLocalIdMacroParameters = (editorActions, localId)=>{
    const localIdNode = editorActions?.getNodeByLocalId?.(localId)?.toJSON();
    const params = localIdNode?.attrs?.parameters;
    // Return a copy of the params object if it exists, otherwise return null
    return params ? {
        ...params
    } : null;
};
const $5a630f948a937af8$export$42f5e9ab021856ba = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        itemId: (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))(),
        link: '',
        title: '',
        type: (0, $8Yw12.ITEM).LINK
    });
const $5a630f948a937af8$export$8623c79a5744076b = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        itemId: (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))(),
        childItems: [],
        title: '',
        type: (0, $8Yw12.ITEM).MENU
    });
const $5a630f948a937af8$export$6c8e1d57a494d583 = (itemsToValidate)=>{
    if (!itemsToValidate || !Array.isArray(itemsToValidate)) return [];
    return itemsToValidate;
};
const $5a630f948a937af8$export$404e7e78d12e7892 = (styles)=>{
    return {
        // use defaults to fill in any missing fields
        ...(0, $6THkE.DEFAULT_STYLES),
        ...styles
    };
};
const $5a630f948a937af8$export$579466658e10543a = ({ localId: localId, editorActions: editorActions })=>{
    const [extensionParameters, setExtensionParameters] = (0, $cozmU.useState)(()=>$5a630f948a937af8$var$fetchLocalIdMacroParameters(editorActions, localId));
    const { items: items } = extensionParameters ?? {};
    (0, $cozmU.useEffect)(()=>{
        const extensionNodeParams = $5a630f948a937af8$var$fetchLocalIdMacroParameters(editorActions, localId);
        setExtensionParameters(extensionNodeParams);
    }, [
        editorActions,
        localId
    ]);
    const updateExtensionParams = (0, $cozmU.useCallback)((newExtensionParameters)=>{
        if (!extensionParameters) return;
        const updatedParams = {
            ...extensionParameters,
            ...newExtensionParameters
        };
        // Save params to ADF and state
        (0, $hiHdh.updateNodeParameters)(editorActions, updatedParams);
        setExtensionParameters(updatedParams);
    }, [
        editorActions,
        extensionParameters
    ]);
    const addItem = (0, $cozmU.useCallback)((item, parentId, position)=>{
        const clonedItems = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(items);
        const updatedItems = (0, $bcbc0d6f4b7dc8cf$export$133e0070ec60504c)($5a630f948a937af8$export$6c8e1d57a494d583(clonedItems), item, parentId, position);
        updateExtensionParams({
            items: updatedItems
        });
    }, [
        items,
        updateExtensionParams
    ]);
    const updateItem = (0, $cozmU.useCallback)((item, title, link)=>{
        const newItem = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(item);
        if (title) newItem.title = title;
        if (link) newItem.link = link;
        const clonedItems = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(items);
        const updatedItems = (0, $bcbc0d6f4b7dc8cf$export$2d1285fd35af5519)($5a630f948a937af8$export$6c8e1d57a494d583(clonedItems), newItem);
        updateExtensionParams({
            items: updatedItems
        });
    }, [
        items,
        updateExtensionParams
    ]);
    const moveItem = (0, $cozmU.useCallback)((item, position, parentId)=>{
        const clonedItems = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(items);
        const itemsWithoutOldEntry = (0, $bcbc0d6f4b7dc8cf$export$49f42e821420f72e)($5a630f948a937af8$export$6c8e1d57a494d583(clonedItems), item.itemId);
        const itemsWithNewEntry = (0, $bcbc0d6f4b7dc8cf$export$133e0070ec60504c)(itemsWithoutOldEntry, item, parentId, position);
        updateExtensionParams({
            items: itemsWithNewEntry
        });
    }, [
        items,
        updateExtensionParams
    ]);
    const deleteItem = (0, $cozmU.useCallback)((itemId)=>{
        const clonedItems = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(items);
        const updatedItems = (0, $bcbc0d6f4b7dc8cf$export$49f42e821420f72e)($5a630f948a937af8$export$6c8e1d57a494d583(clonedItems), itemId);
        updateExtensionParams({
            items: updatedItems
        });
    }, [
        items,
        updateExtensionParams
    ]);
    const createStyleUpdater = (0, $cozmU.useCallback)((updateField)=>(value)=>{
            setExtensionParameters((prevParams)=>{
                if (!prevParams) return null;
                const newParams = {
                    ...prevParams,
                    styles: {
                        ...$5a630f948a937af8$export$404e7e78d12e7892(prevParams.styles),
                        [updateField]: value
                    }
                };
                (0, $hiHdh.updateNodeParameters)(editorActions, newParams);
                return newParams;
            });
        }, [
        editorActions
    ]);
    const extensionActions = (0, $cozmU.useMemo)(()=>({
            addItem: addItem,
            updateItem: updateItem,
            moveItem: moveItem,
            deleteItem: deleteItem,
            updateAlignment: createStyleUpdater('alignment'),
            updateFillColor: createStyleUpdater('fillColor'),
            updateBorder: createStyleUpdater('border'),
            updateCornerStyle: createStyleUpdater('cornerStyle'),
            updateCornerRadius: createStyleUpdater('cornerRadius'),
            updateBorderColor: createStyleUpdater('borderColor'),
            updateTextColor: createStyleUpdater('textColor'),
            updateHighlightColor: createStyleUpdater('highlightColor')
        }), [
        addItem,
        updateItem,
        moveItem,
        deleteItem,
        createStyleUpdater
    ]);
    return {
        extensionParameters: extensionParameters,
        extensionActions: extensionActions
    };
};






var $kA6Zo = parcelRequire("kA6Zo");




/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hekY6 = parcelRequire("hekY6");





var $1zKNa = parcelRequire("1zKNa");


var $iSrRp = parcelRequire("iSrRp");





var $9kbTQ = parcelRequire("9kbTQ");


var $bB0i2 = parcelRequire("bB0i2");





var $fl787 = parcelRequire("fl787");


var $aDtKq = parcelRequire("aDtKq");





var $fYWmN = parcelRequire("fYWmN");


var $cDMxg = parcelRequire("cDMxg");










const $c5b5e7c02851da02$var$draggingStyles = (0, $buxP3.xcss)({
    opacity: 0.5
});
const $c5b5e7c02851da02$var$wrapperStyles = (0, $buxP3.xcss)({
    position: 'relative',
    cursor: 'grab'
});
const $c5b5e7c02851da02$var$previewStyles = (0, $buxP3.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.100',
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.overlay',
    maxWidth: '360px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $c5b5e7c02851da02$export$588e2663e0be32a3 = ({ children: children, item: item, isDragging: isDragging, setIsDragging: setIsDragging, index: index, parentId: parentId, level: level })=>{
    const ref = (0, $cozmU.useRef)(null);
    const [dropIndicatorInstruction, setDropIndicatorInstruction] = (0, $cozmU.useState)();
    const [previewContainer, setPreviewContainer] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        const el = ref.current;
        (0, $bB0i2.default)(el);
        return (0, $aDtKq.combine)((0, $iSrRp.draggable)({
            element: el,
            onDragStart: ()=>setIsDragging(true),
            onDrop: ()=>setIsDragging(false),
            getInitialData: ()=>{
                return {
                    id: item.itemId,
                    parentId: parentId,
                    index: index,
                    type: item.type,
                    item: item
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $cDMxg.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $fYWmN.pointerOutsideOfPreview)({
                        x: "var(--ds-space-200, 16px)",
                        y: "var(--ds-space-100, 8px)"
                    }),
                    render: ({ container: container })=>{
                        setPreviewContainer(container);
                    }
                });
            }
        }), (0, $iSrRp.dropTargetForElements)({
            element: el,
            canDrop: ()=>{
                // Stop user from dragging & dropping into deep nesting.
                // It's possible for users to work around our guardrails here and
                // and nest more levels than we "allow," by dragging and dropping already
                // deeply-nested trees into another deep nested target - as long as
                // the target element isn't exceeding the max level.
                // User will only be halted by some restrictions on the item creation buttons
                // and cursory checks like the ones below.
                // These guardrails are in place to 1. help admins make their content
                // accessible / well designed and 2. enforce scale limits.
                // With 1, we can let a user choose to work around that purposely, but they
                // still won't be able to get around our harder item number limit (see
                // MAXIMUM_ITEM_LIMIT) unless they directly query backend with an ADF update,
                // so 2 is not really a concern either.
                if (level > (0, $5a630f948a937af8$export$3fcb5b76d26bf473)() + 1) return false;
                return true;
            },
            onDragLeave: ()=>{
                setDropIndicatorInstruction(null);
                setPreviewContainer(null);
            },
            onDrop: ()=>{
                setDropIndicatorInstruction(null);
                setPreviewContainer(null);
            },
            onDrag: ({ self: self, source: source })=>{
                const instruction = (0, $1zKNa.extractInstruction)(self.data);
                if (source.data.id === item.itemId || instruction?.type === 'instruction-blocked') setDropIndicatorInstruction(null);
                else setDropIndicatorInstruction(instruction);
            },
            getData: ({ input: input, element: element })=>{
                const data = {
                    id: item.itemId,
                    parentId: parentId,
                    index: index,
                    type: item.type,
                    item: item
                };
                // only menu items can be parents, so block make-child for links
                let blockInstructions = [
                    'make-child'
                ];
                if (item.type === (0, $8Yw12.ITEM).MENU) {
                    blockInstructions = [];
                    // Don't let user reorder-below a menu item that has children,
                    // because the drop indicator shows up under the menu item and
                    // doesn't visually represent the end state (current item will
                    // reorder *after* the menu *plus* all its children).
                    // User will still be able to achieve their desired goal by
                    // reordering above the subsequent item on the same level as
                    // this menu item.
                    // Exception is if this menu item is last in the list. In that case,
                    // they'll need to use a workaround for now by dragging the menu item
                    // upwards instead. @TODO, fix this papercut.
                    if (item.childItems?.length) blockInstructions.push('reorder-below');
                    if (level > (0, $5a630f948a937af8$export$3fcb5b76d26bf473)()) blockInstructions.push('make-child');
                }
                return (0, $1zKNa.attachInstruction)(data, {
                    input: input,
                    element: element,
                    currentLevel: level,
                    indentPerLevel: 0,
                    mode: 'standard',
                    block: blockInstructions
                });
            }
        }));
    }, [
        item,
        setIsDragging,
        parentId,
        index,
        setDropIndicatorInstruction,
        level
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        ref: ref,
        xcss: [
            isDragging && $c5b5e7c02851da02$var$draggingStyles,
            $c5b5e7c02851da02$var$wrapperStyles
        ],
        testId: `draggable-links-menu-item-${item.itemId}`
    }, children, dropIndicatorInstruction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fl787.DropIndicator), {
        instruction: dropIndicatorInstruction
    }) : null), previewContainer && /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $c5b5e7c02851da02$var$previewStyles
    }, item.title), previewContainer));
};









var $1sCHt = parcelRequire("1sCHt");


var $6TaGl = parcelRequire("6TaGl");


var $5wHqn = parcelRequire("5wHqn");















var $iOZNd = parcelRequire("iOZNd");


var $hMaHH = parcelRequire("hMaHH");


var $cJ0FD = parcelRequire("cJ0FD");


var $4yccB = parcelRequire("4yccB");

const $f289f531ad1c09f8$export$17270ac458723b0f = async (link, submitError)=>{
    try {
        const client = new (0, $4yccB.default)();
        const resolvedLinkData = (await client.fetchData(link)).data || {};
        const isInternalResource = resolvedLinkData['atlassian:ari'];
        const externalIconUrl = resolvedLinkData.icon?.url;
        if (!isInternalResource && externalIconUrl) return externalIconUrl;
    } catch (error) {
        submitError?.(error);
    }
    return undefined;
};







const $57fd414daf32f352$export$f508444e7933c2b1 = ({ item: item })=>{
    const [externalIconUrl, setExternalIconUrl] = (0, $cozmU.useState)('');
    const link = item.type === (0, $8Yw12.ITEM).LINK ? item.link : '';
    const { submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    (0, $cozmU.useEffect)(()=>{
        const fetchIconComponent = async ()=>{
            if (link) {
                const url = await (0, $f289f531ad1c09f8$export$17270ac458723b0f)(link, submitError);
                if (url) setExternalIconUrl(url);
            }
        };
        fetchIconComponent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        link
    ]);
    if (externalIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: externalIconUrl,
        height: 16,
        width: 16,
        alt: ""
    });
    if (item.type === (0, $8Yw12.ITEM).LINK) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
        label: ""
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iOZNd))), {
        label: ""
    });
};









var $9DHhW = parcelRequire("9DHhW");


var $ad7Ou = parcelRequire("ad7Ou");


var $fuSOM = parcelRequire("fuSOM");










var $8pCvZ = parcelRequire("8pCvZ");


var $bQmwQ = parcelRequire("bQmwQ");












var $7BfeF = parcelRequire("7BfeF");

var $kB5K2 = parcelRequire("kB5K2");







var $4yg9g = parcelRequire("4yg9g");




const $f50c67b7888f402c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    displayTextLabel: {
        id: "company-hub.links-menu-extension.config-panel.property-config.display-text-label",
        defaultMessage: "Display text"
    },
    displayTextPlaceholder: {
        id: "company-hub.links-menu-extension.config-panel.property-config.display-text-placeholder",
        defaultMessage: "Item name"
    },
    displayTextError: {
        id: "company-hub.links-menu-extension.config-panel.property-config.display-text-error",
        defaultMessage: "Please fill out this field."
    }
});


const $103779f45dadb877$var$errorStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.050',
    gap: 'space.050',
    height: '16px'
});
const $103779f45dadb877$export$4a8624fe9f1d9d1e = ({ itemId: itemId, displayText: displayText, handleOnChange: handleOnChange, isInvalid: isInvalid })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: itemId
    }, formatMessage((0, $f50c67b7888f402c$export$defe85febe8b728c).displayTextLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        value: displayText,
        onChange: handleOnChange,
        placeholder: formatMessage((0, $f50c67b7888f402c$export$defe85febe8b728c).displayTextPlaceholder),
        isInvalid: isInvalid,
        // link picker will still be able to insert a title longer than this
        // and there's no error messaging, but user will stop being able to
        // input more text after 100 chars
        maxLength: 100
    }), isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $103779f45dadb877$var$errorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $f50c67b7888f402c$export$defe85febe8b728c).displayTextError))));
};





const $139899a4cdcd8470$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cancelButtonLabel: {
        id: "company-hub.links-menu-extension.config-panel.property-config.cancel-button-label",
        defaultMessage: "Cancel"
    },
    confirmButtonLabel: {
        id: "company-hub.links-menu-extension.config-panel.property-config.confirm-button-label",
        defaultMessage: "Confirm"
    }
});


const $66131ca3daf51fef$var$configStyles = (0, $buxP3.xcss)({
    margin: 'space.200',
    width: '310px'
});
const $66131ca3daf51fef$var$buttonStyles = (0, $buxP3.xcss)({
    marginTop: 'space.200',
    justifyContent: 'flex-end',
    gap: 'space.050'
});
const $66131ca3daf51fef$var$linkPickerCustomMessages = (0, $kSwu1.defineMessages)({
    submitButtonLabel: {
        id: "company-hub.links-menu-extension.config-panel.property-config.link.submit-button-label",
        defaultMessage: "Confirm"
    }
});
const $66131ca3daf51fef$var$supportedPluginKeys = [
    'confluence',
    'jira',
    'atlas',
    'loom'
];
const $66131ca3daf51fef$export$7aec99e1cacc0106 = ({ extensionActions: extensionActions, handleClose: handleClose, existingItem: existingItem, newItemType: newItemType, parentId: parentId, update: update })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { addItem: addItem, updateItem: updateItem } = extensionActions;
    const { cloudId: cloudId, linkPickerConfig: linkPickerConfig } = (0, $cfM7x.useProductDependencies)();
    // If create new type is passed in, create a new item with default parameters
    const [item] = (0, $cozmU.useState)(()=>{
        if (newItemType === (0, $8Yw12.ITEM).LINK) return (0, $5a630f948a937af8$export$42f5e9ab021856ba)();
        else if (newItemType === (0, $8Yw12.ITEM).MENU) return (0, $5a630f948a937af8$export$8623c79a5744076b)();
        else return existingItem;
    });
    const [textFieldValue, setTextFieldValue] = (0, $cozmU.useState)(item.title);
    const [isError, setIsError] = (0, $cozmU.useState)(false);
    const handleTextFieldChange = (0, $cozmU.useCallback)((event)=>{
        const { value: value } = event.target;
        setTextFieldValue(value);
        setIsError(false);
    }, []);
    // used for link item, extra step to handle link field
    const handleSubmitForLink = (payload)=>{
        // The link picker automatically submits when users select a
        // suggested link from the results, even if they have not
        // specified a title yet or hit Confirm. Here we interrupt
        // auto submission and set the display text to the link's title,
        // if none exists and we have a title from linking platform.
        // Then, when users hit Confirm manually the submission will happen.
        if (textFieldValue.length === 0 && payload.title) // If we have a page title from the link picker then set
        // empty display text to that value
        setTextFieldValue(payload.title);
        else // submit the update with link field
        handleSubmit(payload.url);
    };
    const handleSubmit = (link)=>{
        // do validation for display text field
        if (textFieldValue.length === 0) {
            setIsError(true);
            return;
        }
        // add item if new
        if (!!newItemType) {
            // set properties on new item
            item.title = textFieldValue;
            if (link) item.link = link;
            addItem(item, parentId);
        } else updateItem(item, textFieldValue, link);
        createAnalyticsEvent?.({
            type: 'sendTrackEvent',
            data: {
                action: !!newItemType ? 'added' : 'updated',
                actionSubject: 'item',
                source: (0, $bQmwQ.LINKS_MENU_EXTENSION_ANALYTIC_SOURCE),
                attributes: {
                    itemType: item.link ? 'link' : 'menu'
                }
            }
        }).fire();
        handleClose();
    };
    const { isLoading: isLoading, plugins: plugins } = (0, $8pCvZ.useLinkPickerPlugins)({
        cloudId: cloudId,
        product: 'confluence'
    });
    const filteredPlugins = (0, $cozmU.useMemo)(()=>{
        return plugins.filter((plugin)=>{
            return plugin.tabKey && $66131ca3daf51fef$var$supportedPluginKeys.includes(plugin.tabKey);
        });
    }, [
        plugins
    ]);
    // Use custom plugins if provided, otherwise use default filtered plugins
    const pluginsToUse = linkPickerConfig?.linkPickerPlugins || filteredPlugins;
    const isLoadingPlugins = linkPickerConfig?.linkPickerPlugins ? false : isLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $66131ca3daf51fef$var$configStyles,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $103779f45dadb877$export$4a8624fe9f1d9d1e), {
        itemId: item.itemId,
        displayText: textFieldValue,
        handleOnChange: handleTextFieldChange,
        isInvalid: isError
    }), item.type === (0, $8Yw12.ITEM).LINK ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuSOM.default), {
        plugins: pluginsToUse,
        isLoadingPlugins: isLoadingPlugins,
        url: item.link,
        displayText: item.title,
        onSubmit: handleSubmitForLink,
        onCancel: handleClose,
        hideDisplayText: true,
        paddingLeft: "0px",
        paddingRight: "0px",
        paddingBottom: "0px",
        disableWidth: true,
        customMessages: $66131ca3daf51fef$var$linkPickerCustomMessages,
        onContentResize: update
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $66131ca3daf51fef$var$buttonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleClose
    }, formatMessage((0, $139899a4cdcd8470$export$defe85febe8b728c).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: ()=>handleSubmit()
    }, formatMessage((0, $139899a4cdcd8470$export$defe85febe8b728c).confirmButtonLabel))));
};









var $aRvnq = parcelRequire("aRvnq");


var $9d7Pd = parcelRequire("9d7Pd");

var $8oBbn = parcelRequire("8oBbn");





var $lpNn5 = parcelRequire("lpNn5");















var $kTb7m = parcelRequire("kTb7m");




var $6IL1T = parcelRequire("6IL1T");















const $6e3cca665228d1d0$var$message = (0, $kSwu1.defineMessages)({
    addLinkButtonText: {
        id: "company-hub.links-menu-extension.config-panel.add-link-button.text",
        defaultMessage: "Link"
    },
    addLinkButtonDescription: {
        id: "company-hub.links-menu-extension.config-panel.add-link-button.description",
        defaultMessage: "Add important links"
    },
    addMenuButtonText: {
        id: "company-hub.links-menu-extension.config-panel.add-menu-button.text",
        defaultMessage: "Menu"
    },
    addMenuButtonDescription: {
        id: "company-hub.links-menu-extension.config-panel.add-menu-button.description",
        defaultMessage: "Group related links together"
    },
    menuSubItemCreationDisabledTooltipText: {
        id: "company-hub.links-menu-extension.config-panel.add-menu-button.disabled.tooltip-text",
        defaultMessage: "You have reached the maximum number of nested levels."
    }
});
var $6e3cca665228d1d0$export$2e2bcd8739ae039 = $6e3cca665228d1d0$var$message;


const $6a07483b640d0b00$var$menuGroupStyles = (0, $buxP3.xcss)({
    width: '300px'
});
const $6a07483b640d0b00$export$92ef8f592bb35119 = ({ setIsConfiguring: setIsConfiguring, setNewItemType: setNewItemType, isAddMenuSubItemDisabled: isAddMenuSubItemDisabled = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const handleAddLinkClick = ()=>{
        setIsConfiguring(true);
        setNewItemType((0, $8Yw12.ITEM).LINK);
    };
    const handleAddMenuClick = ()=>{
        setIsConfiguring(true);
        setNewItemType((0, $8Yw12.ITEM).MENU);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $6a07483b640d0b00$var$menuGroupStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
        minWidth: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: ""
        }),
        description: intl.formatMessage((0, $6e3cca665228d1d0$export$2e2bcd8739ae039).addLinkButtonDescription),
        onClick: handleAddLinkClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6e3cca665228d1d0$export$2e2bcd8739ae039).addLinkButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6e3cca665228d1d0$export$2e2bcd8739ae039).menuSubItemCreationDisabledTooltipText),
        canAppear: ()=>isAddMenuSubItemDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        isDisabled: isAddMenuSubItemDisabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iOZNd))), {
            label: ""
        }),
        description: intl.formatMessage((0, $6e3cca665228d1d0$export$2e2bcd8739ae039).addMenuButtonDescription),
        onClick: handleAddMenuClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6e3cca665228d1d0$export$2e2bcd8739ae039).addMenuButtonText)))));
};


















var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");

var $aRGok = parcelRequire("aRGok");


var $4aRua = parcelRequire("4aRua");










const $9d6362d76aaa3db1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    invokeDeleteButtonText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.delete-item-button.text",
        defaultMessage: "Delete item"
    },
    modalHeaderText: {
        id: "company-hub.links-menu-extension.config-panel.delete-nested-items-modal.title-text",
        defaultMessage: "Delete item"
    },
    modalDescriptionText: {
        id: "company-hub.links-menu-extension.config-panel.delete-nested-items-modal.description-text",
        defaultMessage: "This action will delete this item and all nested items."
    },
    confirmDeleteButtonText: {
        id: "company-hub.links-menu-extension.config-panel.delete-nested-items-modal.confirm-text",
        defaultMessage: "Delete"
    },
    cancelDeleteButtonText: {
        id: "company-hub.links-menu-extension.config-panel.delete-nested-items-modal.cancel-text",
        defaultMessage: "Cancel"
    }
});


const $4d8213e10e6bbe53$export$9ed99085725e367e = ({ item: item, extensionActions: extensionActions })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const openModal = ()=>setIsOpen(true);
    const closeModal = ()=>setIsOpen(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { deleteItem: deleteItem } = extensionActions;
    const handleDeleteClick = ()=>{
        if (item.type === (0, $8Yw12.ITEM).MENU && item.childItems?.length) openModal();
        else handleConfirmDelete();
    };
    const handleConfirmDelete = ()=>{
        createAnalyticsEvent?.({
            type: 'sendTrackEvent',
            data: {
                action: 'deleted',
                actionSubject: 'item',
                source: (0, $bQmwQ.LINKS_MENU_EXTENSION_ANALYTIC_SOURCE),
                attributes: {
                    itemType: item.link ? 'link' : 'menu'
                }
            }
        }).fire();
        deleteItem(item.itemId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        onClick: handleDeleteClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9d6362d76aaa3db1$export$defe85febe8b728c).invokeDeleteButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: closeModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9d6362d76aaa3db1$export$defe85febe8b728c).modalHeaderText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9d6362d76aaa3db1$export$defe85febe8b728c).modalDescriptionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: closeModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9d6362d76aaa3db1$export$defe85febe8b728c).cancelDeleteButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "warning",
        onClick: handleConfirmDelete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9d6362d76aaa3db1$export$defe85febe8b728c).confirmDeleteButtonText))))));
};





const $6b7c00b7c19455fc$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    openLinkButtonText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.open-link-button.text",
        defaultMessage: "Open the link"
    },
    editPropertiesButtonText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.edit-properties-button.text",
        defaultMessage: "Edit properties"
    },
    addSubItemButtonText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.add-sub-item-button.text",
        defaultMessage: "Add sub item"
    },
    moveItemUpText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.move-item-up.text",
        defaultMessage: "Move up"
    },
    moveItemDownText: {
        id: "company-hub.links-menu-extension.config-panel.item-dropdown.move-item-down.text",
        defaultMessage: "Move down"
    },
    itemCreationDisabledTooltipText: {
        id: "company-hub.links-menu-extension.config-panel.sub-item-button.disabled.tooltip-text",
        defaultMessage: "You have reached the maximum number of items that can be added to a links menu."
    }
});


const $87fb9051120c4608$export$4837f2e6e199256e = ({ extensionActions: extensionActions, index: index, isFirst: isFirst, isLast: isLast, item: item, parentId: parentId, level: level, numberItems: numberItems, setIsPopupOpen: setIsPopupOpen, setIsConfiguring: setIsConfiguring, setNewItemType: setNewItemType })=>{
    const { moveItem: moveItem } = extensionActions;
    const [isNestedPopupOpen, setIsNestedPopupOpen] = (0, $cozmU.useState)(false);
    const handleOpenLinkClick = ()=>{
        setIsPopupOpen(false);
    };
    const handleEditPropertiesClick = ()=>{
        setIsConfiguring(true);
        setNewItemType(undefined);
    };
    const handleMoveUpClick = ()=>{
        moveItem(item, index - 1, parentId);
        setIsPopupOpen(false);
    };
    const handleMoveDownClick = ()=>{
        moveItem(item, index + 1, parentId);
        setIsPopupOpen(false);
    };
    const handleSubItemPopupClose = ()=>setIsNestedPopupOpen(false);
    const reachedMaximumNestingLevel = level >= (0, $5a630f948a937af8$export$3fcb5b76d26bf473)();
    const reachedMaximumItems = numberItems >= (0, $5a630f948a937af8$export$8555315c03db9dc2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, item.type === (0, $8Yw12.ITEM).LINK && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
        href: item.link,
        target: "_blank",
        onClick: handleOpenLinkClick,
        isDisabled: !item.link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).openLinkButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        onClick: handleEditPropertiesClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).editPropertiesButtonText)), item.type === (0, $8Yw12.ITEM).MENU && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).itemCreationDisabledTooltipText),
        canAppear: ()=>reachedMaximumItems
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isNestedPopupOpen,
        placement: "auto",
        onClose: handleSubItemPopupClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a07483b640d0b00$export$92ef8f592bb35119), {
                isAddMenuSubItemDisabled: reachedMaximumNestingLevel,
                setIsConfiguring: setIsConfiguring,
                setNewItemType: setNewItemType
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                ...triggerProps,
                isDisabled: reachedMaximumItems,
                isSelected: isNestedPopupOpen,
                onClick: ()=>setIsNestedPopupOpen(true),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
                    label: "Add sub item"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).addSubItemButtonText))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        isDisabled: isFirst,
        onClick: handleMoveUpClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).moveItemUpText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        isDisabled: isLast,
        onClick: handleMoveDownClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6b7c00b7c19455fc$export$defe85febe8b728c).moveItemDownText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d8213e10e6bbe53$export$9ed99085725e367e), {
        item: item,
        extensionActions: extensionActions
    }));
};





const $feca6551d72aad31$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    moreButtonLabel: {
        id: "company-hub.links-menu-extension.config-panel.property-config.more-button-label",
        defaultMessage: "More"
    }
});


const $aaf980be749ec808$var$wrapperStyles = (0, $buxP3.xcss)({
    height: '32px',
    paddingLeft: 'space.100',
    paddingRight: 'space.050'
});
const $aaf980be749ec808$var$unselectedStyles = (0, $buxP3.xcss)({
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        borderRadius: 'radius.small'
    }
});
const $aaf980be749ec808$var$selectedStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small',
    background: "var(--ds-background-selected, #E9F2FE)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-selected, #1868DB)"}`
});
const $aaf980be749ec808$var$entryStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $aaf980be749ec808$var$titleStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $aaf980be749ec808$export$b2ddf7d8171e1c98 = 16;
// Config panel is not resizable
const $aaf980be749ec808$var$APPROX_BUFFERED_CONFIG_PANEL_WIDTH = 255;
const $aaf980be749ec808$export$52cf4656f89a6ced = ({ extensionActions: extensionActions, isFirst: isFirst, isLast: isLast, index: index, item: item, parentId: parentId, level: level, numberItems: numberItems, isDragging: isDragging })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(false);
    const [isConfiguring, setIsConfiguring] = (0, $cozmU.useState)(false);
    const [newItemType, setNewItemType] = (0, $cozmU.useState)(undefined);
    const handleClose = ()=>{
        setIsPopupOpen(false);
        setIsConfiguring(false);
        setNewItemType(undefined);
    };
    const handleMoreButtonClick = ()=>{
        setIsPopupOpen(!isPopupOpen);
        setIsConfiguring(false);
        setNewItemType(undefined);
    };
    const configProps = newItemType ? {
        newItemType: newItemType,
        parentId: item.itemId
    } : {
        existingItem: item
    };
    const popupAdjustLeftPx = $aaf980be749ec808$var$APPROX_BUFFERED_CONFIG_PANEL_WIDTH - $aaf980be749ec808$export$b2ddf7d8171e1c98 * level;
    const popupAdjustDownPx = item?.type === (0, $8Yw12.ITEM).MENU ? 50 : 80;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        alignItems: "center",
        justifyContent: "space-between",
        xcss: [
            $aaf980be749ec808$var$wrapperStyles,
            isConfiguring ? $aaf980be749ec808$var$selectedStyles : $aaf980be749ec808$var$unselectedStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        alignItems: "center",
        columnGap: "space.100",
        xcss: $aaf980be749ec808$var$entryStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57fd414daf32f352$export$f508444e7933c2b1), {
        item: item
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $aaf980be749ec808$var$titleStyles,
        testId: `links-menu-item-title-${index}-${item.itemId}`
    }, item.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isPopupOpen && !isDragging,
        onClose: handleClose,
        placement: "auto",
        // move popup to left of list item when item config is invoked,
        // so user can see what they are editing
        offset: isConfiguring ? [
            popupAdjustDownPx,
            popupAdjustLeftPx
        ] : undefined,
        content: ({ update: update })=>{
            if (isConfiguring) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $66131ca3daf51fef$export$7aec99e1cacc0106), {
                extensionActions: extensionActions,
                handleClose: handleClose,
                update: update,
                ...configProps
            });
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $87fb9051120c4608$export$4837f2e6e199256e), {
                extensionActions: extensionActions,
                isFirst: isFirst,
                isLast: isLast,
                index: index,
                level: level,
                item: item,
                parentId: parentId,
                numberItems: numberItems,
                setIsPopupOpen: setIsPopupOpen,
                setIsConfiguring: setIsConfiguring,
                setNewItemType: setNewItemType
            });
        },
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                onClick: handleMoreButtonClick,
                appearance: "subtle",
                spacing: "compact",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $feca6551d72aad31$export$defe85febe8b728c).moreButtonLabel),
                isSelected: isPopupOpen && !isConfiguring
            })
    }));
};


const $0c52aed093252330$var$treeStyles = null;
const $0c52aed093252330$export$b7801be30ff65271 = ({ extensionActions: extensionActions, nodes: nodes, parentId: parentId, level: level = 0, numberItems: numberItems })=>{
    const { moveItem: moveItem } = extensionActions;
    (0, $cozmU.useEffect)(()=>{
        return (0, $iSrRp.monitorForElements)({
            onDrop ({ source: source, location: location }) {
                const destination = location.current.dropTargets[0];
                if (destination?.data && source?.data) {
                    const sourceData = source.data;
                    const destinationData = destination.data;
                    const instruction = (0, $1zKNa.extractInstruction)(destinationData); // source and destination should be unique
                    if (sourceData.id !== destinationData.id) {
                        if (instruction?.type === 'reorder-above' || instruction?.type === 'reorder-below') {
                            // if source and destination have same parent, then we are reordering within the list
                            // and the index depends on whether the source is above or below the destination
                            const index = destinationData.index || 0;
                            let newIndex = instruction?.type === 'reorder-above' ? index : index + 1;
                            if (sourceData.parentId === destinationData.parentId) {
                                if (sourceData.index < index) newIndex = instruction?.type === 'reorder-above' ? index - 1 : index;
                            }
                            moveItem(sourceData.item, newIndex, destinationData.parentId);
                        }
                        if (instruction?.type === 'make-child') moveItem(sourceData.item, 0, destinationData.id);
                    }
                }
            }
        });
    }, [
        nodes,
        moveItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        style: {
            listStyleType: 'none'
        },
        className: (0, $hekY6.default)([
            "_19bvidpf _17d4pxbi"
        ])
    }, nodes.map((node, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0c52aed093252330$var$LinksMenuItemTreeNode, {
            key: node.itemId,
            extensionActions: extensionActions,
            node: node,
            isFirst: index === 0,
            isLast: index === nodes.length - 1,
            index: index,
            parentId: parentId,
            level: level,
            numberItems: numberItems
        })));
};
const $0c52aed093252330$var$LinksMenuItemTreeNode = ({ extensionActions: extensionActions, node: node, isFirst: isFirst, isLast: isLast, index: index, parentId: parentId, level: level, numberItems: numberItems })=>{
    const [isDragging, setIsDragging] = (0, $cozmU.useState)(false);
    const newLevel = level + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5b5e7c02851da02$export$588e2663e0be32a3), {
        item: node,
        index: index,
        parentId: parentId,
        isDragging: isDragging,
        setIsDragging: setIsDragging,
        level: level
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aaf980be749ec808$export$52cf4656f89a6ced), {
        key: node.itemId,
        extensionActions: extensionActions,
        index: index,
        isFirst: isFirst,
        isLast: isLast,
        item: node,
        parentId: parentId,
        level: level,
        numberItems: numberItems,
        isDragging: isDragging
    })), node.childItems && !isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0c52aed093252330$export$b7801be30ff65271, {
        extensionActions: extensionActions,
        nodes: node.childItems,
        parentId: node.itemId,
        level: newLevel,
        numberItems: numberItems
    }));
};












var $gFEZF = parcelRequire("gFEZF");





var $4ez2K = parcelRequire("4ez2K");









const $810d9a2aadbfde1e$var$message = (0, $kSwu1.defineMessages)({
    newItemButtonText: {
        id: "company-hub.links-menu-extension.config-panel.new-item-button.text",
        defaultMessage: "New item"
    },
    itemCreationDisabledTooltipText: {
        id: "company-hub.links-menu-extension.config-panel.new-item-button.disabled.tooltip-text",
        defaultMessage: "You have reached the maximum number of items that can be added to a links menu."
    }
});
var $810d9a2aadbfde1e$export$2e2bcd8739ae039 = $810d9a2aadbfde1e$var$message;



const $33cfc65cb4c0f1da$export$f9da8ac0bf4c10b = ({ extensionActions: extensionActions, numberItems: numberItems })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(false);
    const [isConfiguring, setIsConfiguring] = (0, $cozmU.useState)(false);
    const [newItemType, setNewItemType] = (0, $cozmU.useState)(undefined);
    const handleOnClose = ()=>{
        setIsPopupOpen(false);
        setIsConfiguring(false);
        setNewItemType(undefined);
    };
    const isAddDisabled = numberItems >= (0, $5a630f948a937af8$export$8555315c03db9dc2)();
    const handleAddNewItemButtonClick = ()=>{
        setIsPopupOpen(!isPopupOpen);
        setIsConfiguring(false);
        setNewItemType(undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isPopupOpen,
        onClose: handleOnClose,
        placement: "bottom-end",
        fallbackPlacements: [
            'auto'
        ],
        content: ({ update: update })=>isConfiguring && newItemType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $66131ca3daf51fef$export$7aec99e1cacc0106), {
                extensionActions: extensionActions,
                handleClose: handleOnClose,
                update: update,
                newItemType: newItemType
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a07483b640d0b00$export$92ef8f592bb35119), {
                setIsConfiguring: setIsConfiguring,
                setNewItemType: setNewItemType
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $810d9a2aadbfde1e$export$2e2bcd8739ae039).itemCreationDisabledTooltipText),
                canAppear: ()=>isAddDisabled
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                onClick: handleAddNewItemButtonClick,
                isSelected: isPopupOpen && !isConfiguring,
                isDisabled: isAddDisabled,
                shouldFitContainer: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
                alignItems: "center",
                justifyContent: "center",
                gap: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                label: ""
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $810d9a2aadbfde1e$export$2e2bcd8739ae039).newItemButtonText))))
    });
};


const $56913d8e8d66d0b7$var$itemsTabStyles = (0, $buxP3.xcss)({
    width: '100%',
    paddingTop: 'space.200'
});
const $56913d8e8d66d0b7$var$itemsTreeStyles = (0, $buxP3.xcss)({
    marginTop: 'space.200'
});
const $56913d8e8d66d0b7$export$869bcddc95554001 = ({ extensionParameters: extensionParameters, extensionActions: extensionActions })=>{
    const totalItemCount = (0, $cozmU.useMemo)(()=>(0, $5a630f948a937af8$export$b503abd6de82eca1)(extensionParameters.items), [
        extensionParameters.items
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "column",
        xcss: $56913d8e8d66d0b7$var$itemsTabStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33cfc65cb4c0f1da$export$f9da8ac0bf4c10b), {
        extensionActions: extensionActions,
        numberItems: totalItemCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "column",
        xcss: $56913d8e8d66d0b7$var$itemsTreeStyles
    }, extensionParameters.items && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0c52aed093252330$export$b7801be30ff65271), {
        extensionActions: extensionActions,
        nodes: extensionParameters.items,
        numberItems: totalItemCount
    })));
};





const $4ea311f5ca17d214$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "company-hub.links-menu-extension.config-panel.title",
        defaultMessage: "Links menu"
    },
    preamble: {
        id: "company-hub.links-menu-extension.config-panel.preamble",
        defaultMessage: "Add links and organize them with submenus. {linksMenuSupportLink}"
    },
    preambleWithoutSupportLink: {
        id: "company-hub.links-menu-extension.config-panel.preamble-without-support-link",
        defaultMessage: "Add links and organize them with submenus."
    },
    preambleSupportLinkLabel: {
        id: "company-hub.links-menu-extension.config-panel.preamble-link.label",
        defaultMessage: "Learn more about links menu"
    },
    itemsLabel: {
        id: "company-hub.links-menu-extension.config-panel.items.label",
        defaultMessage: "Items"
    },
    stylesLabel: {
        id: "company-hub.links-menu-extension.config-panel.styles.label",
        defaultMessage: "Styles"
    }
});











var $4yUlE = parcelRequire("4yUlE");

var $5ddnJ = parcelRequire("5ddnJ");




/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 









var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");


var $4ikjJ = parcelRequire("4ikjJ");


var $eBTV9 = parcelRequire("eBTV9");

var $f9375c5bd6aa36bb$exports = {};
$f9375c5bd6aa36bb$exports = new URL("CenterAlignment.d485d2ee.svg", import.meta.url).toString();

var $dc657cb9a098154e$exports = {};
$dc657cb9a098154e$exports = new URL("LeftAlignment.39a4cc93.svg", import.meta.url).toString();

var $dc97e266cc3b1d6b$exports = {};
$dc97e266cc3b1d6b$exports = new URL("RightAlignment.ee73794d.svg", import.meta.url).toString();








const $62ffd5ec12cb339a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    alignmentSectionTitle: {
        id: "company-hub.links-menu-extension.alignment.title",
        defaultMessage: "Alignment"
    },
    centerOption: {
        id: "company-hub.links-menu-extension.center.option",
        defaultMessage: "Center"
    },
    rightOption: {
        id: "company-hub.links-menu-extension.right.option",
        defaultMessage: "Right"
    },
    leftOption: {
        id: "company-hub.links-menu-extension.left.option",
        defaultMessage: "Left"
    },
    collapseSectionLabel: {
        id: "company-hub.links-menu-extension.section.collapse.label",
        defaultMessage: "Collapse section"
    },
    expandSectionLabel: {
        id: "company-hub.links-menu-extension.section.expand.label",
        defaultMessage: "Expand section"
    },
    fixedOption: {
        id: "company-hub.links-menu-extension.fixed.option",
        defaultMessage: "Fixed at top"
    }
});


const $8df22c16dac442a4$var$styles = {
    options: "_2rko12b0 _1h6d1l7x _189ee4h9 _1dqonqa1 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _bfhksm61 _4cvxq98m _irr3daj9"
};
const $8df22c16dac442a4$export$f77ede0ff8fdecea = ({ alignment: alignment, updateAlignment: updateAlignment })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const alignmentOptions = [
        {
            option: (0, $8Yw12.ALIGNMENT).CENTER,
            label: (0, $62ffd5ec12cb339a$export$defe85febe8b728c).centerOption,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($f9375c5bd6aa36bb$exports)))
        },
        {
            option: (0, $8Yw12.ALIGNMENT).RIGHT,
            label: (0, $62ffd5ec12cb339a$export$defe85febe8b728c).rightOption,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($dc97e266cc3b1d6b$exports)))
        },
        {
            option: (0, $8Yw12.ALIGNMENT).LEFT,
            label: (0, $62ffd5ec12cb339a$export$defe85febe8b728c).leftOption,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($dc657cb9a098154e$exports)))
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eBTV9.CollapsibleItem), {
        title: formatMessage((0, $62ffd5ec12cb339a$export$defe85febe8b728c).alignmentSectionTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.200"
    }, alignmentOptions.map(({ option: option, label: label, image: image })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
            key: option,
            xcss: $8df22c16dac442a4$var$styles.options,
            onClick: ()=>updateAlignment(option)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            spread: "space-between",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
            value: "default radio",
            label: formatMessage(label),
            name: `radio-${option}`,
            testId: `radio-${option}${alignment === option ? '--selected' : ''}`,
            isChecked: alignment === option
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: image,
            alt: ""
        }))))));
};


/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 






var $w6R6I = parcelRequire("w6R6I");


var $lRXxm = parcelRequire("lRXxm");


var $bsSbN = parcelRequire("bsSbN");


var $jAG9k = parcelRequire("jAG9k");














var $cXCJB = parcelRequire("cXCJB");

var $4sYZY = parcelRequire("4sYZY");







var $1ipaC = parcelRequire("1ipaC");


var $e9Sxn = parcelRequire("e9Sxn");

var $gKJso = parcelRequire("gKJso");


var $4WDWC = parcelRequire("4WDWC");


var $4pBmf = parcelRequire("4pBmf");


var $iJCWb = parcelRequire("iJCWb");





var $eafQX = parcelRequire("eafQX");







const $ff55793b554baa82$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    backgroundTitle: {
        id: "company-hub.links-menu-extension.background.title",
        defaultMessage: "Background"
    },
    backgroundColor: {
        id: "company-hub.links-menu-extension.background.color",
        defaultMessage: "Background color"
    },
    borderColor: {
        id: "company-hub.links-menu-extension.border.color",
        defaultMessage: "Border color"
    },
    borderPosition: {
        id: "company-hub.links-menu-extension.border.position",
        defaultMessage: "Border position"
    },
    noBorderLabel: {
        id: "company-hub.links-menu-extension.no.border.label-text",
        defaultMessage: "None"
    },
    allBordersLabel: {
        id: "company-hub.links-menu-extension.all.borders.label-text",
        defaultMessage: "All sides"
    },
    bottomBorderLabel: {
        id: "company-hub.links-menu-extension.bottom.border.label-text",
        defaultMessage: "Bottom border"
    },
    cornerRadius: {
        id: "company-hub.links-menu-extension.config.corner.radius.non-final",
        defaultMessage: "Corners"
    }
});


const $1659d476a828e673$var$styles = {
    borderOptionContainer: "_1rjcv77o _18zr1b66 _bfhkysee",
    dropdownTrigger: "_bfhksm61",
    border: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1",
    selected: "_1h6d1w55 _bfhk15s3"
};
const $1659d476a828e673$export$caf212aab59548f5 = ({ border: border, updateBorder: updateBorder, borderColor: borderColor, updateBorderColor: updateBorderColor, fillColor: fillColor, updateFillColor: updateFillColor, cornerStyle: cornerStyle, updateCornerStyle: updateCornerStyle, cornerRadius: cornerRadius, updateCornerRadius: updateCornerRadius, isReadableFillColor: isReadableFillColor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap, borderColorMap: borderColorMap, emptyColorMap: emptyColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode); // Advanced-theming opt-in: when the framework is mounted with gate ON,
    // swap the swatch palette for the 22-shade brand map and translate the
    // picker hex <-> ADF storage shape via the palette helpers. Gate OFF (or
    // when the provider isn't mounted, e.g. Confluence Company Hub) falls
    // back to today's behavior unchanged.
    const theming = (0, $4pBmf.useHubTheming)();
    const isAdvancedThemingEnabled = theming?.isAdvancedThemingEnabled === true;
    const palette = isAdvancedThemingEnabled ? theming?.palette : undefined;
    const primaryColor = isAdvancedThemingEnabled ? theming?.primaryColor : undefined;
    const v2BgMap = isAdvancedThemingEnabled ? theming?.brandBackgroundColorMap : undefined;
    const v2BorderMap = isAdvancedThemingEnabled ? theming?.brandBorderColorMap : undefined; // Bg + border are always populated by the manifest's defaultParameters
    // (or DEFAULT_STYLES), so the fallback ref isn't hit in practice — it's
    // only used by resolveAdfColorForPicker if the stored value is null.
    // Pass primary.200 as a sensible visible default.
    const fillPickerValue = palette ? (0, $e9Sxn.resolveAdfColorForPicker)(fillColor, palette, 'primary.200', primaryColor) : fillColor;
    const borderPickerValue = palette ? (0, $e9Sxn.resolveAdfColorForPicker)(borderColor, palette, 'primary.200', primaryColor) : borderColor;
    const handleFillColorChange = (color)=>{
        // Note: text auto-flip on bg change is handled centrally by the
        // `useAutoTransitioningColors` hook in the StylesTab parent, so we
        // only need to persist the bg here. When v2 is ON, store as the
        // palette var-ref form so the bg tracks future brand-color changes.
        updateFillColor(palette ? (0, $gKJso.toAdfColor)(color, palette) : color);
    };
    const handleBorderColorChange = (color)=>{
        if (border === (0, $8Yw12.BORDER).NONE) // if user interacts with border color then they need a border
        // position in order to see their changes
        updateBorder((0, $8Yw12.BORDER).ALL_SIDES);
         // When v2 is ON, store brand-palette swatches as palette var-refs so
        // the border tracks future brand-color changes. The 4 neutral
        // swatches (white, color.border hex, color.border.bold hex, black)
        // and any custom hex fall through `toAdfColor` and get stored
        // verbatim as raw hex.
        updateBorderColor(palette ? (0, $gKJso.toAdfColor)(color, palette) : color);
    };
    const handleBorderOptionClick = (borderOption)=>updateBorder(borderOption);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eBTV9.CollapsibleItem), {
        title: formatMessage((0, $ff55793b554baa82$export$defe85febe8b728c).backgroundTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $ff55793b554baa82$export$defe85febe8b728c).backgroundColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        analyticsSource: "linksMenuExtensionConfigBackgroundColor",
        builtInColorMap: v2BgMap ?? (hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap),
        isReadableColor: isReadableFillColor,
        onChange: handleFillColorChange,
        value: fillPickerValue,
        pickerTitle: (0, $ff55793b554baa82$export$defe85febe8b728c).backgroundColor,
        showCustomPalette: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $ff55793b554baa82$export$defe85febe8b728c).borderPosition)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100"
    }, [
        {
            borderOption: (0, $8Yw12.BORDER).NONE,
            label: (0, $ff55793b554baa82$export$defe85febe8b728c).noBorderLabel,
            IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($bsSbN)))
        },
        {
            borderOption: (0, $8Yw12.BORDER).ALL_SIDES,
            label: (0, $ff55793b554baa82$export$defe85febe8b728c).allBordersLabel,
            IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($lRXxm)))
        },
        {
            borderOption: (0, $8Yw12.BORDER).BOTTOM,
            label: (0, $ff55793b554baa82$export$defe85febe8b728c).bottomBorderLabel,
            IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($jAG9k)))
        }
    ].map(({ borderOption: borderOption, label: label, IconComponent: IconComponent })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: borderOption,
            content: formatMessage(label)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
            xcss: (0, $w6R6I.cx)($1659d476a828e673$var$styles.borderOptionContainer, $1659d476a828e673$var$styles.border, border === borderOption && $1659d476a828e673$var$styles.selected),
            onClick: ()=>handleBorderOptionClick(borderOption),
            testId: `border-${borderOption}${border === borderOption ? '--selected' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
            color: border === borderOption ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon, #292A2E)",
            label: formatMessage(label)
        })));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $ff55793b554baa82$export$defe85febe8b728c).borderColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        analyticsSource: "linksMenuExtensionConfigBorderColor",
        builtInColorMap: v2BorderMap ?? (hideDefaultColorPalette ? emptyColorMap : borderColorMap),
        onChange: (color)=>color && handleBorderColorChange(color),
        value: borderPickerValue,
        pickerTitle: (0, $ff55793b554baa82$export$defe85febe8b728c).borderColor,
        showCustomPalette: true
    })), isCornerRadiusEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJCWb.RangeField), {
        label: (0, $ff55793b554baa82$export$defe85febe8b728c).cornerRadius,
        minValue: (0, $4WDWC.HUB_CORNER_RADIUS_MIN),
        maxValue: (0, $4WDWC.HUB_CORNER_RADIUS_MAX),
        step: (0, $4WDWC.HUB_CORNER_RADIUS_STEP),
        value: (0, $4WDWC.resolveHubCornerRadius)((0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle === (0, $8Yw12.CORNERS).SHARP ? (0, $hjUDQ.CornerStyle).SQUARED : (0, $hjUDQ.CornerStyle).ROUNDED) ?? theming?.cornerRadius),
        updateRangeValue: updateCornerRadius,
        analyticSource: "linksMenuExtensionConfigCornerRadius",
        prefix: "cornerRadius",
        unit: "px"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ipaC.CornerStyleConfig), {
        cornerStyleValue: cornerStyle,
        updateCornerStyle: updateCornerStyle,
        roundCornerValue: (0, $8Yw12.CORNERS).ROUND,
        squareCornerValue: (0, $8Yw12.CORNERS).SHARP
    })));
};




































const $9a3a137207e2d451$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    textTitle: {
        id: "company-hub.links-menu-extension.text.title",
        defaultMessage: "Text"
    },
    textColor: {
        id: "company-hub.links-menu-extension.text.color",
        defaultMessage: "Text color"
    },
    selectedStateColor: {
        id: "company-hub.links-menu-extension.selected.state.color",
        defaultMessage: "Selected state color"
    }
});


const $8f77d4fb60002199$export$b8599b1e18c4960e = ({ highlightColor: highlightColor, updateHighlightColor: updateHighlightColor, textColor: textColor, updateTextColor: updateTextColor, isReadableTextColor: isReadableTextColor })=>{
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette } = branding ?? {};
    const { highlightColorMap: highlightColorMap, textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // Advanced-theming opt-in: when gate ON, swap to the 22-shade brand
    // palette and translate hex <-> ADF var-ref storage. Gate OFF or
    // non-help-center hosts (e.g. Confluence Company Hub which doesn't
    // mount the provider) take the legacy passthrough branch unchanged.
    const theming = (0, $4pBmf.useHubTheming)();
    const isAdvancedThemingEnabled = theming?.isAdvancedThemingEnabled === true;
    const palette = isAdvancedThemingEnabled ? theming?.palette : undefined;
    const primaryColor = isAdvancedThemingEnabled ? theming?.primaryColor : undefined;
    const v2BgMap = isAdvancedThemingEnabled ? theming?.brandBackgroundColorMap : undefined;
    // Text + highlight are always populated (manifest seeds a WCAG-readable
    // AK token, and useAutoTransitioningColors keeps text in sync on bg
    // change), so the fallback ref isn't hit in practice — it's only used
    // by resolveAdfColorForPicker if the stored value is null. Pass
    // primary.1000 as a sensible visible default (combo of primary.200 bg).
    const textPickerValue = palette ? (0, $e9Sxn.resolveAdfColorForPicker)(textColor, palette, 'primary.1000', primaryColor) : textColor;
    const highlightPickerValue = palette ? (0, $e9Sxn.resolveAdfColorForPicker)(highlightColor, palette, 'primary.1000', primaryColor) : highlightColor;
    const handleTextColorChange = (color)=>{
        updateTextColor(palette ? (0, $gKJso.toAdfColor)(color, palette) : color);
    };
    const handleHighlightColorChange = (color)=>{
        updateHighlightColor(palette ? (0, $gKJso.toAdfColor)(color, palette) : color);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eBTV9.CollapsibleItem), {
        title: formatMessage((0, $9a3a137207e2d451$export$defe85febe8b728c).textTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9a3a137207e2d451$export$defe85febe8b728c).textColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        analyticsSource: "linksMenuExtensionConfigTextColor",
        builtInColorMap: v2BgMap ?? (hideDefaultColorPalette ? emptyColorMap : textColorMap),
        isReadableColor: isReadableTextColor,
        onChange: handleTextColorChange,
        value: textPickerValue,
        pickerTitle: (0, $9a3a137207e2d451$export$defe85febe8b728c).textColor,
        showCustomPalette: true,
        showTextIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9a3a137207e2d451$export$defe85febe8b728c).selectedStateColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        analyticsSource: "linksMenuExtensionConfigHighlightColor",
        builtInColorMap: v2BgMap ?? (hideDefaultColorPalette ? emptyColorMap : highlightColorMap),
        onChange: handleHighlightColorChange,
        value: highlightPickerValue,
        pickerTitle: (0, $9a3a137207e2d451$export$defe85febe8b728c).selectedStateColor,
        showCustomPalette: true
    }))));
};


const $5e16192a3222c241$var$stylesTabStyles = (0, $buxP3.xcss)({
    width: '100%'
});
const $5e16192a3222c241$export$3989a31619203135 = ({ parameters: parameters, actions: actions })=>{
    const { styles: styles } = parameters ?? {};
    const { updateBorder: updateBorder, updateBorderColor: updateBorderColor, updateCornerRadius: updateCornerRadius, updateCornerStyle: updateCornerStyle, updateFillColor: updateFillColor, updateHighlightColor: updateHighlightColor, updateTextColor: updateTextColor } = actions;
    const isReadableFillColor = (color)=>(0, $4yUlE.isReadable)(color, styles.textColor);
    const isReadableTextColor = (color)=>(0, $4yUlE.isReadable)(color, styles.fillColor);
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    (0, $5ddnJ.useAutoTransitioningColors)(styles.fillColor, isReadableTextColor, styles.textColor, updateTextColor, branding?.defaultParameters);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "column",
        xcss: $5e16192a3222c241$var$stylesTabStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8df22c16dac442a4$export$f77ede0ff8fdecea), {
        updateAlignment: actions.updateAlignment,
        alignment: parameters.styles.alignment
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1659d476a828e673$export$caf212aab59548f5), {
        border: styles.border,
        updateBorder: updateBorder,
        borderColor: styles.borderColor,
        updateBorderColor: updateBorderColor,
        fillColor: styles.fillColor,
        updateFillColor: updateFillColor,
        cornerStyle: styles.cornerStyle,
        updateCornerStyle: updateCornerStyle,
        cornerRadius: styles.cornerRadius,
        updateCornerRadius: updateCornerRadius,
        isReadableFillColor: isReadableFillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8f77d4fb60002199$export$b8599b1e18c4960e), {
        highlightColor: styles.highlightColor,
        updateHighlightColor: updateHighlightColor,
        textColor: styles.textColor,
        updateTextColor: updateTextColor,
        isReadableTextColor: isReadableTextColor
    }));
};


const $6e1151b045a252d2$var$SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/set-up-a-menu-of-important-links-on-company-hub/';
const $6e1151b045a252d2$var$stickyFooterStyles = (0, $buxP3.xcss)({
    paddingInline: 'space.050',
    paddingBlock: 'space.300',
    marginInline: 'space.negative.050',
    display: 'flex',
    flexDirection: 'column',
    position: 'sticky',
    bottom: 'space.0',
    backgroundColor: 'elevation.surface'
});
const $6e1151b045a252d2$var$LinksMenuFooter = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $6e1151b045a252d2$var$stickyFooterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dDC4.ConfigPanelFeedbackCollector), {
        source: "linksMenuExtension",
        type: (0, $hjUDQ.FeedbackType).LINKS_MENU
    }));
const $6e1151b045a252d2$export$d4ee58941fdf2d2c = ({ closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showConfigPreambleSupportLink: showConfigPreambleSupportLink } = (0, $cfM7x.useProductDependencies)();
    const { extensionParameters: extensionParameters, extensionActions: extensionActions } = (0, $5a630f948a937af8$export$579466658e10543a)({
        localId: localId,
        editorActions: editorActions
    });
    if (!extensionParameters) return null;
    const tabSections = [
        {
            label: formatMessage((0, $4ea311f5ca17d214$export$defe85febe8b728c).itemsLabel),
            value: 'items',
            tabContent: [
                {
                    sectionId: 'main',
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $56913d8e8d66d0b7$export$869bcddc95554001), {
                        extensionParameters: extensionParameters,
                        extensionActions: extensionActions
                    })
                }
            ]
        },
        {
            label: formatMessage((0, $4ea311f5ca17d214$export$defe85febe8b728c).stylesLabel),
            value: 'styles',
            tabContent: [
                {
                    sectionId: 'general',
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5e16192a3222c241$export$3989a31619203135), {
                        parameters: extensionParameters,
                        actions: extensionActions
                    })
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a96iv.ExtensionsConfigWrapper), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4ea311f5ca17d214$export$defe85febe8b728c).title),
        footerComponent: $6e1151b045a252d2$var$LinksMenuFooter,
        closeConfigPanel: closeConfigPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...showConfigPreambleSupportLink ? (0, $4ea311f5ca17d214$export$defe85febe8b728c).preamble : (0, $4ea311f5ca17d214$export$defe85febe8b728c).preambleWithoutSupportLink,
        values: {
            linksMenuSupportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                target: "_blank",
                href: $6e1151b045a252d2$var$SUPPORT_LINK
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4ea311f5ca17d214$export$defe85febe8b728c).preambleSupportLinkLabel))
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4zyjT.ConfigPanelGrouping), {
        source: "linksMenuExtensionConfig",
        tabSections: tabSections
    }));
};
module.exports["LinksMenuConfigPanelContent"] = $6e1151b045a252d2$export$d4ee58941fdf2d2c;

});


//# sourceMappingURL=links-menu-extension.7410987b.js.map
